<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import PageHomepage
</style>

<script>
    import Grid     from '../../common/components/Grid.vue'
    import GridItem from '../../common/components/GridItem.vue'
    import Locator from '../../common/components/locator/Locator.vue'
    import Newsfeed from '../../common/components/Newsfeed.vue'
    import Tabset from '../../common/components/tabset/Tabset.vue'
    import Tab from '../../common/components/tabset/Tab.vue'

    import FeedArticles from '../../component/feed-articles/FeedArticles.vue'
    import Highlights from '../../component/highlights/Highlights.vue'
    import PushBanner from '../../component/banner/PushBanner.vue'
    import TabsetProducts from '../../component/tabset-products/TabsetProducts.vue'
    import Testimonies from '../../component/testimonies/Testimonies.vue'
    import TilesetsServices from '../../component/tilesets-services/TilesetsServices.vue'

    import HeroSwiper from './HeroSwiper.vue'
    import { onMounted, nextTick } from 'vue'
     export default {
        name: "PageHomepage",
        components: {
            FeedArticles,
            HeroSwiper,
            Highlights,
            Locator,
            PushBanner,
            Tabset,
            TabsetProducts,
            Tab,
            Testimonies,
            TilesetsServices,
            Grid,
            GridItem,
            Newsfeed,
        },
        setup(){
          onMounted(() => {
            nextTick(() => {
              const titles = document.querySelectorAll('svg title');
              titles.forEach(title => {
                title.remove();
              });
            });
          })

      }
    }

</script>
